import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import MoneyTextBox from 'components/common/money_text_box'
import styles from './edit_amount.less'
import EditForm from '../edit_form'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'
import { HeadingText } from '@paypalcorp/pp-react'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n('components/edit_glimpse/edit_amount')

class EditAmount extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    currencyCode: PropTypes.string.isRequired,
    campaignType: PropTypes.string.isRequired,
    formattedMaxGoalAmount: PropTypes.string,
  }

  render() {
    const {
      fields: { goal },
      campaignType = CROWD_FUNDING,
      formattedMaxGoalAmount,
    } = this.props

    return (
      <EditForm {...this.props}>
        {campaignType === CROWD_FUNDING ? (
          <HeadingText size="md" styleName="title_cf">
            {i18n('title_cf')}
          </HeadingText>
        ) : (
          <div styleName="title" role="heading" aria-level="1">
            {i18n('title')}
          </div>
        )}
        <MoneyTextBox
          {...goal}
          data-pa-focus="goal"
          dataNemo="goal-amount"
          currencyCode={this.props.currencyCode}
          title={
            campaignType === CROWD_FUNDING
              ? i18n('goal_amount_title', {
                  maxGoalAmount: formattedMaxGoalAmount,
                })
              : i18n('goal_amount')
          }
          disableCents={false}
          autoFocus={true}
        />
        <button
          data-nemo="save"
          data-pa-click="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditAmount, styles)
